"use client";

import React from "react";
import { Building2, Map, PackageSearch, Settings } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const solutions = [{
  title: "Engineering",
  description: "This phase involves the overall planning, master theming, attraction design, and creation of detailed architectural and engineering blueprints for the entire park.",
  icon: Map,
  bgClass: "bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/15.jpg)]",
  titleClassName: "absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/15-1.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/15-2.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/15-3.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/15-4.jpg)]"
}, {
  title: "Procurement",
  description: "It covers the sourcing, contracting, and supply of all specialized equipment, ride systems, themed elements, and materials as specified in the design.",
  icon: PackageSearch,
  bgClass: "bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/16.jpg)]",
  titleClassName: "absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/17.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/17.jpg)]"
}, {
  title: "Construction",
  description: "This is the physical realization phase, including site construction, installation of rides and facilities, thematic finishing, and comprehensive testing and commissioning.",
  icon: Building2,
  bgClass: "bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/17.jpg)]",
  titleClassName: "absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/16.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/16.jpg)] absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/16.jpg)]"
}, {
  title: "\xA0 Operations",
  description: "This long-term phase manages the park’s daily operations, maintenance, guest services, and entertainment to ensure a safe, immersive, and profitable visitor experience.",
  icon: Settings,
  bgClass: "bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/18.jpg)]",
  titleClassName: "absolute inset-0 bg-white/85 !bg-[url(https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/18.jpg)]"
}];
export default function IntegratedSolutions() {
  return <section className="py-24 bg-background">
      <div className="container mx-auto px-6">

        <h2 className="text-4xl font-bold mb-12 text-primary">
          Integrated EPCO Solutions
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {solutions.map(solution => <Card key={solution.title} className="group relative overflow-hidden rounded-xl transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl">

              {/* 背景图片 */}
              <div className={`absolute inset-0 ${solution.bgClass} bg-cover bg-center transition-transform duration-700 group-hover:scale-110`} />

              {/* 渐变遮罩 */}
              <div className={`${solution.titleClassName || ""} absolute inset-0 bg-white/85`} />

              {/* 内容 */}
              <div className="relative z-10 flex flex-col h-full p-6">

                <CardHeader>

                  {/* 图标 */}
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-lg bg-primary/10 text-primary transition-all duration-500 group-hover:bg-primary group-hover:text-white">

                    <solution.icon className="h-7 w-7" />

                  </div>

                  {/* 标题 */}
                  <CardTitle className="leading-none font-bold text-black mb-2 !text-3xl">
                    {solution.title}
                  </CardTitle>

                </CardHeader>

                <CardContent className="mt-auto">

                  {/* 文案 */}
                  <p className="text-sm font-light leading-relaxed !font-sans !opacity-[1] !text-[hsl(193,82%,31%)] !rounded !bg-transparent !text-left">
                    {solution.description}
                  </p>

                </CardContent>

              </div>

            </Card>)}

        </div>

      </div>
    </section>;
}